import apiClient from "../../../../services/apiClient";
import config from "../../../../config";
import axios from "axios";

const BASE_API = config.API_BASE_URL;

const handleAccountProfilePictureUpload = async (
  event: React.ChangeEvent<HTMLInputElement>,
  setProfilePictureUrl: (url: string) => void,
  setFormError: (error: string) => void,
  accountProfileIdInt: number
) => {
  const file = event.target.files?.[0];
  setFormError("");

  if (file) {
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/webp",
      "image/heic",
      "image/heif",
    ];
    if (!allowedTypes.includes(file.type)) {
      setFormError("Please upload a valid image file (JPEG, PNG, WebP only).");
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    if (!accountProfileIdInt) {
      setFormError("Failed to upload the photo. Please try again.");
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_API}account_profiles/${accountProfileIdInt}/set_photo/`,
        formData
      );

      if (response.status === 200) {
        setProfilePictureUrl(response.data.profile_image_url);
      } else {
        setFormError("Failed to upload the photo. Please try again.");
      }
    } catch (error) {
      console.error("Error uploading photo:", error);
      setFormError("An error occurred while uploading the photo.");
    }
  }
};

export default handleAccountProfilePictureUpload;
